import React from 'react';

type PopupContextType = {
    isOpen: boolean,
    setIsOpen: (
        open: boolean
    ) => void
}

export const PopupContext = React.createContext<PopupContextType>({
    isOpen: false,
    setIsOpen: () => { }
})